import { inject, InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';

import {
  SkillsImportProgressMessage,
  SkillsImportProgressTrackService,
} from './skills-import-progress-track.service';

export interface SkillsImportProgressTracker {
  track: (importId: number) => Observable<SkillsImportProgressMessage>;
}

export const SKILLS_IMPORT_PROGRESS_TRACKER = new InjectionToken<SkillsImportProgressTracker>(
  'SKILLS_IMPORT_PROGRESS_TRACKER',
  {
    providedIn: 'root',
    factory: () => inject(SkillsImportProgressTrackService),
  },
);
